import { quaternionToEuler as p, eulerToQuaternion as x } from "../../core/math/utils.js";
function W(u, l) {
  const c = p(
    u.rotX[l],
    u.rotY[l],
    u.rotZ[l],
    u.rotW[l]
  );
  u.eulerX[l] = c.x, u.eulerY[l] = c.y, u.eulerZ[l] = c.z;
}
function z(u, l) {
  const c = x(
    u.eulerX[l],
    u.eulerY[l],
    u.eulerZ[l]
  );
  u.rotX[l] = c.x, u.rotY[l] = c.y, u.rotZ[l] = c.z, u.rotW[l] = c.w;
}
function d(u, l, c) {
  l.posX[c] = u.posX[c], l.posY[c] = u.posY[c], l.posZ[c] = u.posZ[c], l.rotX[c] = u.rotX[c], l.rotY[c] = u.rotY[c], l.rotZ[c] = u.rotZ[c], l.rotW[c] = u.rotW[c], l.eulerX[c] = u.eulerX[c], l.eulerY[c] = u.eulerY[c], l.eulerZ[c] = u.eulerZ[c], l.scaleX[c] = u.scaleX[c], l.scaleY[c] = u.scaleY[c], l.scaleZ[c] = u.scaleZ[c];
}
function E(u, l) {
  u.posX[l] = 0, u.posY[l] = 0, u.posZ[l] = 0, u.rotX[l] = 0, u.rotY[l] = 0, u.rotZ[l] = 0, u.rotW[l] = 1, u.eulerX[l] = 0, u.eulerY[l] = 0, u.eulerZ[l] = 0, u.scaleX[l] = 1, u.scaleY[l] = 1, u.scaleZ[l] = 1;
}
function Q(u, l, c, Y, X, Z) {
  Y.set(
    u.posX[l],
    u.posY[l],
    u.posZ[l]
  ), X.set(
    u.rotX[l],
    u.rotY[l],
    u.rotZ[l],
    u.rotW[l]
  ), Z.set(
    u.scaleX[l],
    u.scaleY[l],
    u.scaleZ[l]
  ), c.compose(Y, X, Z);
}
function q(u, l, c, Y, X, Z) {
  u.decompose(Y, X, Z), l.posX[c] = Y.x, l.posY[c] = Y.y, l.posZ[c] = Y.z, l.rotX[c] = X.x, l.rotY[c] = X.y, l.rotZ[c] = X.z, l.rotW[c] = X.w, W(l, c), l.scaleX[c] = Z.x, l.scaleY[c] = Z.y, l.scaleZ[c] = Z.z;
}
export {
  Q as composeTransformMatrix,
  d as copyTransform,
  q as decomposeTransformMatrix,
  E as setTransformIdentity,
  W as syncEulerFromQuaternion,
  z as syncQuaternionFromEuler
};
//# sourceMappingURL=utils.js.map
